import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { Link } from "react-router-dom";
import { scrollFunction, scrollToTop, scrollToSection } from "./scroll.js";
import obsFlag from "./imgs/obs_flag.gif";
import browserSource from "./imgs/browser_source.gif";
import addCustom from "./imgs/add_custom.gif";
import elgato from "./imgs/elgato.svg";
import dock from "./imgs/dock.png";
import faqs from "./FAQ/tutorial.json";
import CollapsibleFAQ from "./FAQ/CollapsibleFaq.jsx";

function Streamers() {
  const [showButton, setShowButton] = useState(false);
  // const [activeIndex, setActiveIndex] = useState(null);

  // const handleCollapsibleClick = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(scrollFunction());
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="leave-top_margin">
      <Layout>
        {showButton && (
          <button id="myBtn" onClick={scrollToTop} style={{ display: "block" }}>
            <svg
              style={{ color: "#7cd959" }}
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="currentColor"
              className="bi bi-arrow-up-circle-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                fill="#4fe83b"
              ></path>
            </svg>
          </button>
        )}
        <div className="streamer_header">
          <h1>
            Getting Started with <b className="highlighted">Streamfog</b>
          </h1>
        </div>
        <div className="streamer_body">
          <div className="table_contents">
            <h2 className="highlighted">Table of Contents</h2>
            <div className="table-of-contents__item">
              <Link to="#" onClick={() => scrollToSection("how")}>
                1. Understanding Streamfog: How It Works
              </Link>
            </div>
            <div className="table-of-contents__item">
              <Link to="#" onClick={() => scrollToSection("setup")}>
                2. Setup
              </Link>
            </div>
            <ol className="setup_list">
              <li>
                {" "}
                <Link to="#" onClick={() => scrollToSection("obs")}>
                  Preparing OBS
                </Link>
              </li>
              <li>
                <Link to="#" onClick={() => scrollToSection("browser")}>
                  Adding Streamfog Browser Source to OBS
                </Link>
              </li>
              <li>
                <Link to="#" onClick={() => scrollToSection("alerts")}>
                  Adding and Managing Alerts
                </Link>
              </li>
            </ol>
            <div className="table-of-contents__item">
              <Link
                to="#;"
                onClick={() => scrollToSection("advanced_features")}
              >
                3. Advanced Features
              </Link>
            </div>
            <ol className="setup_list">
              <li>
                {" "}
                <Link to="#" onClick={() => scrollToSection("spotlight")}>
                  Spotlight
                </Link>
              </li>
              <li>
                {" "}
                <Link to="#" onClick={() => scrollToSection("cam_calib")}>
                  Camera Calibration
                </Link>
              </li>
              <li>
                <Link to="#" onClick={() => scrollToSection("obs_dock")}>
                  OBS Streamfog Dock
                </Link>
              </li>
              <li>
                <Link to="#" onClick={() => scrollToSection("streamdeck")}>
                  Streamdeck Plugin
                </Link>
              </li>
            </ol>
            <div className="table-of-contents__item">
              <Link to="#" onClick={() => scrollToSection("faq")}>
                4. FAQ & Troubleshooting
              </Link>
            </div>
          </div>
          <div className="table_body">
            <div className="table_html">
              <div id="how">
                <h1 className="highlighted">
                  Understanding Streamfog: How It Works
                </h1>
                <p>
                  Streamfog revolutionizes live streaming by seamlessly
                  integrating your virtual and physical environment. Using an
                  intelligent and efficient process, it creates a unique and
                  interactive experience for your viewers. Here's how it works:
                </p>
                <ol>
                  <li>
                    <b className="highlighted">Reading Your Webcam:</b>
                    <p>
                      Streamfog continuously captures the visuals from your
                      webcam, forming the foundation for the augmented reality
                      experience.
                    </p>
                  </li>
                  <li>
                    <b className="highlighted">Streamer Detection:</b>
                    <p>
                      Leveraging AI, Streamfog identifies you, the streamer,
                      within the video stream. This allows for a flawless blend
                      between the real and virtual worlds.
                    </p>
                  </li>
                  <li>
                    <b className="highlighted">3D Injection:</b>
                    <p>
                      {" "}
                      A transparent video is then played between the streamer
                      and the background. This video can include custom
                      animations, effects, or even 3D objects that interact with
                      your room. Imagine your walls breaking, logos emerging, or
                      objects moving—virtually anything is possible!
                    </p>
                  </li>
                  <li>
                    <b className="highlighted">Efficient and Unnoticeable:</b>
                    <p>
                      The entire Streamfog process runs smoothly on most
                      systems, allowing you to add these captivating elements
                      without impacting your stream's performance.
                    </p>
                  </li>
                </ol>
                <p>
                  The result is served as a browser source that can be
                  effortlessly added to OBS with just a few clicks.
                </p>
                <p>
                  All of the above happens withing the browser source.
                  <b className="highlighted">
                    No installation of a new app, no virtual camera, no green
                    screen. Simple and easy.
                  </b>
                </p>
              </div>
              <div id="setup">
                <h1 className="highlighted">Setting Up Streamfog</h1>
                <ul>
                  <li>
                    <h2>
                      Go to <b className="highlighted">Settings</b> and
                      configure your camera
                    </h2>
                    <p>
                      Make sure to allow camera access and apply your settings
                      before jumping to the next step.
                    </p>
                  </li>
                  <li>
                    <h2 id="obs">
                      Preparing <b className="highlighted">OBS</b>
                    </h2>
                    <p>
                      Integrating Streamfog into your OBS setup is
                      straightforward, but there's one important step to ensure
                      that the augmented reality magic can happen. OBS needs
                      permission to access your webcam through its browser
                      source, and for this, we need to make a small adjustment.
                      Here's what you need to do:
                    </p>
                    <h4 className="highlighted">Add the Special Flag to OBS</h4>
                    <p>
                      OBS uses a special component called chromium to display
                      web pages, but by default, it can't ask for permission to
                      use your webcam. To overcome this limitation, you need to
                      add a flag to your OBS desktop shortcut.
                    </p>
                    <ol>
                      <li>
                        <b className="highlighted">
                          Right-click on your OBS shortcut and select
                          'Properties'.
                        </b>
                      </li>
                      <li>
                        <b className="highlighted">
                          In the 'Target' field, add{" "}
                          <span
                            style={{
                              fontFamily: "monospace",
                              color: "red",
                              margin: 2,
                            }}
                          >
                            --use-fake-ui-for-media-stream
                          </span>
                          at the end of the line (add a space between).
                        </b>
                      </li>
                      <li>
                        <b className="highlighted">
                          Click 'Apply' and then 'OK.'
                        </b>
                      </li>
                      <li>
                        <b className="highlighted">Restart OBS</b>
                      </li>
                      <br />
                      <img
                        src={obsFlag}
                        alt="Placeholder for gif showing how to do this"
                      />
                    </ol>

                    <p>
                      This flag allows the browser source in OBS to use the
                      webcam, enabling Streamfog's augmented reality features to
                      come to life.
                    </p>

                    <h4 className="highlighted">Is This Safe?</h4>
                    <p>
                      We understand that modifying settings can be concerning,
                      but rest assured, this change has no security or safety
                      implications. It simply means that the browser within OBS
                      can read the camera if it opens a web page that
                      specifically requests it. Your privacy and security remain
                      intact, and this change only affects your OBS browser
                      source. You're in full control and can trust that this
                      adjustment is safe and necessary for Streamfog's immersive
                      features.
                    </p>
                  </li>
                  <li>
                    <h2 id="browser">
                      Adding{" "}
                      <b className="highlighted">Streamfog Browser Source</b> to
                      OBS
                    </h2>
                    <p>
                      After you've added the OBS flag, follow these simple steps
                      to add your personalized camera URL to OBS:
                    </p>
                    <ol>
                      <li>
                        <b className="highlighted">
                          Copy the personalized camera URL:
                        </b>{" "}
                        This URL is unique to you, so it's important to keep it
                        to yourself.
                      </li>
                      <li>
                        <b className="highlighted">
                          Create a new Browser Source:
                        </b>
                        <ul>
                          <li>Paste the Camera URL.</li>
                          <li>
                            For width and height, choose your selected camera
                            resolution.
                          </li>
                          <li>
                            Check "custom fps" and change the FPS to 60
                            (Optional).
                          </li>
                          <li>
                            In page permission, select "Advanced Access to OBS"
                            if you want to use the spotlight feature. (Optional)
                          </li>
                        </ul>
                      </li>
                      <li>
                        <b className="highlighted">Done:</b> Your browser should
                        now show your camera.
                      </li>
                      <br />
                      <img
                        src={browserSource}
                        alt="Placeholder for gif showing how to do this"
                      />
                    </ol>
                    <p>
                      You can now use this browser source and it will act like
                      your Webcam source. Make sure to duplicate it between
                      scenes instead of creating new ones. If you have any
                      problems, refer to the Troubleshooting section or contact
                      our support team.
                    </p>
                  </li>
                  <li>
                    <h2 id="alerts">
                      Adding and Managing{" "}
                      <b className="highlighted">Alerts: Your Guide</b>
                    </h2>
                    <p>
                      With Streamfog, you can easily add, manage, and play
                      exciting alerts that elevate your streaming experience.
                      Whether you're looking to access our inbuilt marketplace
                      or upload custom alerts, we've got you covered. Here's
                      how:
                    </p>

                    <h3 className="highlighted">Your Dashboard</h3>
                    <p>
                      Your Streamfog dashboard is your command center. Here,
                      you'll find all the alerts you've added to your library.
                      These can be alerts from our marketplace or custom ones
                      you've uploaded. Navigating your dashboard is simple and
                      intuitive. (Placeholder for gif showing the dashboard)
                    </p>

                    <h3 className="highlighted">Exploring the 3D Overlays</h3>
                    <p>
                      Our inbuilt marketplace is home to an array of
                      pre-designed alerts ready to be added to your library.
                      Browse through different categories, themes, and styles to
                      find the perfect match for your stream. Adding alerts from
                      the marketplace is just a click away.
                    </p>

                    <h3 className="highlighted">Uploading Custom Alerts</h3>
                    <p>
                      If you have a custom alert you'd like to use, the
                      uploading process is seamless. You can upload your custom
                      alert on the marketplace page. If you have questions about
                      the format and requirements for a custom overlay, please
                      refer to our detailed guide{" "}
                      <Link to="/artists">here</Link>.
                    </p>

                    <h3 className="highlighted">
                      Where Do I Get Custom Alerts?
                    </h3>
                    <p>
                      Custom alerts are a fantastic way to create a unique and
                      personalized streaming experience, and with Streamfog,
                      getting them is easy. We're proud to offer custom alerts
                      designed by our experienced team of 3D artists—the OG's of
                      AR alerts for Twitch. Since no one has done it before, our
                      team's expertise is unparalleled in creating engaging and
                      interactive AR alerts tailored to your needs.
                    </p>
                    <p>
                      You can purchase custom alerts directly from us by either
                      scheduling a meeting or filling out a form within our app.
                      Our user-friendly interface guides you through the
                      process, making it simple to bring your creative vision to
                      life. (Placeholder for gif showing how to schedule a
                      meeting or fill out the form)
                    </p>
                    <p>
                      If you prefer to design your custom alerts or work with an
                      external artist, you can still upload them to your
                      library, following the guidelines found{" "}
                      <Link to="/artists">here</Link>.
                    </p>
                    <br />
                    <img
                      src={addCustom}
                      alt="Placeholder for gif showing how to do this"
                    />
                  </li>
                </ul>
              </div>
              <div id="advanced_features">
                <h1 className="highlighted">Advanced Features</h1>
                <ul>
                  <li>
                    <h2 id="streamdeck">Streamdeck Plugin</h2>
                    <p>
                      Simply copy your remote key from your settings into the
                      Plugin and you are good to go.
                    </p>
                    <Link
                      to="https://apps.elgato.com/plugins/com.streamfog.main"
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        style={{
                          border: "2px solid #7cd959",
                          borderRadius: 10,
                          display: "inline-flex",
                          alignItems: "center",
                          padding: 10,
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={elgato}
                          alt="Download the Plugin"
                          style={{ width: 50 }}
                        />
                        <span
                          style={{
                            marginLeft: 10,
                            color: "#7cd959",
                            fontWeight: "bold",
                          }}
                        >
                          Get the Plugin
                        </span>
                      </div>
                    </Link>
                    <br />
                    <br />
                  </li>
                  <li>
                    <h2 id="spotlight">
                      Spotlight: Emphasizing your Cam during Alerts
                    </h2>
                    <p>
                      Streamfog's spotlight feature is designed to give you the
                      ability to emphasize the 3D alerts that interact with your
                      room, even when the webcam view in your OBS scene is not
                      the main focus. This is particularly useful for streamers
                      who prioritize gameplay footage but still want to enhance
                      their stream with immersive alerts.
                    </p>
                    <h4 className="highlighted">How does it work?</h4>
                    <p>
                      The spotlight feature allows you to create a momentary
                      focus on the 3D alerts by setting an origin scene (your
                      regular gameplay scene) and a target scene (an enlarged
                      camera view). When a 3D alert is triggered, your OBS scene
                      will automatically switch to the target scene, and then
                      return to the original gameplay scene once the alert has
                      played.
                    </p>
                  </li>
                  <li>
                    <h2 id="cam_calib">
                      Cam Reference Image: Consistency for Your 3D Alerts
                    </h2>
                    <p>
                      When using Streamfog's immersive 3D alerts that interact
                      with your room, consistency is key. Your alerts are
                      designed to work with a specific camera angle and room
                      layout, and any accidental shift can disrupt the 3D
                      illusion. That's why we've introduced the camera reference
                      image feature.
                    </p>
                    <h4 className="highlighted">What it does</h4>
                    <p>
                      This feature allows you to upload a reference image of
                      your camera's view - the same one you might have sent to
                      an artist when creating your custom alert. If your camera
                      angle changes accidentally, you can use this image to
                      recalibrate your setup, ensuring that the 3D alerts
                      continue to work seamlessly. Upload it in your Settings,
                      toggle it on an off from your dashboard.
                    </p>
                  </li>
                  <li>
                    <h2 id="obs_dock">OBS Streamfog Dock</h2>
                    <p>
                      Streamfog's Dashboard can be easily integrated into OBS as
                      a browser dock that allows streamers to manage and trigger
                      their 3D alerts directly within OBS. This functionality
                      provides an efficient way to handle your 3D alerts without
                      the need to navigate away from your main streaming
                      interface. <br />
                      Simply go to Docks -{">"} Custom Browser Docks and add
                      "app.streamfog.com/dashboard".
                    </p>
                    <div>
                      <img
                        src={dock}
                        alt="Screenshot showing how to integrate Streamfog's Dashboard into OBS"
                        style={{ height: 500, width: "auto" }}
                      />
                    </div>
                  </li>
                </ul>
              </div>
              
                
                {/* <div className="questions-container">
                  <div className="question">
                    <button
                      className={`collapsible ${
                        activeIndex === 0 ? "active" : ""
                      }`}
                      onClick={() => handleCollapsibleClick(0)}
                    >
                      1. Can I use Streamfog on Youtube, Kick or FB Gaming?
                    </button>
                    {activeIndex === 0 && (
                      <div className="content">
                        <p>
                          We are currently only supporting Twitch. While Kick
                          has currently no public API, we are implementing
                          Youtube support.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="question">
                    <button
                      className={`collapsible ${
                        activeIndex === 1 ? "active" : ""
                      }`}
                      onClick={() => handleCollapsibleClick(1)}
                    >
                      2. Where can I find Streamfog tutorials?
                    </button>
                    {activeIndex === 1 && (
                      <div className="content">
                        <p>
                          Currently, there are only a few tutorials created by
                          us. Hey, if you're a YouTuber looking for an
                          unfulfilled niche, maybe crafting some Streamfog
                          tutorials is a golden opportunity! 😉
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="question">
                    <button
                      className={`collapsible ${
                        activeIndex === 2 ? "active" : ""
                      }`}
                      onClick={() => handleCollapsibleClick(2)}
                    >
                      3. Does Streamfog support Vtubers?
                    </button>
                    {activeIndex === 2 && (
                      <div className="content">
                        <p>
                          Currently not. But if you are an active Vtuber that
                          wants to explore what could be done with Streamfog,
                          drop us a DM!
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="question">
                    <button
                      className={`collapsible ${
                        activeIndex === 3 ? "active" : ""
                      }`}
                      onClick={() => handleCollapsibleClick(3)}
                    >
                      4. My camera is not shown in the OBS browser source.
                    </button>
                    {activeIndex === 3 && (
                      <div className="content">
                        <p>Make sure that:</p>
                        <ul>
                          <li>
                            you selected your camera in the settings page of our
                            app and saved it.
                          </li>
                          <li>
                            your OBS shortcut has the{" "}
                            <code>--use-fake-ui-for-media-stream</code> flag
                            added.
                          </li>
                          <li>
                            your webcam is not already in your scene as a Video
                            Capture Device. No other program should read your
                            camera.
                          </li>
                          <li>
                            you refresh your OBS Browser source or add it from
                            scratch if it doesn't work.
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div> */}
                 <CollapsibleFAQ  faqs={faqs} />
            
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default Streamers;
